var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-weight-bold mb-5"},[_vm._v(_vm._s(_vm.$t("for"))+" "+_vm._s(_vm.invoice.from_name))]),_c('div',[_vm._v(_vm._s(_vm.$t('proprietor')))])])}
var staticRenderFns = []

export { render, staticRenderFns }